import { render, staticRenderFns } from "./wkText.vue?vue&type=template&id=93c38d8c&scoped=true"
import script from "./wkText.vue?vue&type=script&lang=js"
export * from "./wkText.vue?vue&type=script&lang=js"
import style0 from "./wkText.vue?vue&type=style&index=0&id=93c38d8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c38d8c",
  null
  
)

export default component.exports